import axios from "./productInstance";

const removeBundleItems = async (
    productId: string,
    bundleId?: string | null
): Promise<string | null> => {
    try {
        const bundleUrl = `/bundles/${bundleId}/products/${productId}`;
        const response = await axios.delete(bundleUrl);

        return response?.data?.message || null;
    } catch (error: any) {
        console.error("Error removing bundle item:", error?.response?.data || error.message);

        const errorMessage =
            error?.response?.data?.error?.replace(/_/g, " ") || "An error occurred while removing the bundle item.";

        throw new Error(errorMessage);
    }
};

export default removeBundleItems;
